<template>
    <div class="dashboard-container">
        <!-- 科技感装饰线条 -->
        <div class="tech-lines">
            <div class="line-top"></div>
            <div class="line-bottom"></div>
            <div class="corner corner-tl"></div>
            <div class="corner corner-tr"></div>
            <div class="corner corner-bl"></div>
            <div class="corner corner-br"></div>
        </div>

        <!-- 头部 -->
        <header class="dashboard-header">
            <div class="header-left">
                <div class="logo-container">
                    <div class="logo-icon">
                        <img src="@/assets/images/dashboard/logo.png" alt="" srcset="" class="logo-img">
                    </div>
                </div>
            </div>
            <div class="header-center">
                <span class="title">云知印智慧驾驶舱</span>
            </div>
            <div class="header-right">
                <span class="datetime">{{ currentDateTime }}</span>
            </div>
        </header>

        <!-- 主体内容 -->
        <main class="dashboard-main">
            <!-- 上半区 -->
            <div class="top-section">
                <!-- 左侧面板 -->
                <div class="panel-wrapper left-panel">
                    <h3 class="panel-title">全国设备分布</h3>
                    <div class="panel">
                        <div class="panel-content">
                            <ChinaDeviceMap :fontSizes="chartFontSizes" />
                        </div>
                    </div>
                </div>

                <!-- 中央面板 -->
                <div class="panel-wrapper center-panel">
                    <h3 class="panel-title">云知印自助文印印量总数</h3>
                    <div class="panel transparent-panel" style="box-shadow: none;">
                        <div class="panel-content">
                            <!-- 总印量显示 -->
                            <div class="total-count-display">
                                <div>
                                    <CountTo :startVal="previousPrintCount" :endVal="totalPages || totalPrintCount"
                                        :duration="1000" :decimals="0" separator="," :autoplay="true" :useEasing="true"
                                        class="main-number" />
                                    <span class="unit">页</span>
                                </div>
                            </div>

                            <!-- 统计指标 -->
                            <div class="stats-grid">
                                <div class="stat-item">
                                    <div class="stat-label">当日订单量（个）</div>
                                    <div class="stat-value orange">
                                        <CountTo :startVal="0" :endVal="todayOrderCount || 50379" :duration="1000"
                                            :decimals="0" separator="," :autoplay="true" :useEasing="true" />
                                    </div>
                                </div>
                                <div class="stat-item">
                                    <div class="stat-label">设备接入数（台）</div>
                                    <div class="stat-value orange">
                                        <!-- <CountTo
                                            :startVal="0"
                                            :endVal="runningDeviceCount"
                                            :duration="1000"
                                            :decimals="0"
                                            separator=","
                                            :autoplay="true"
                                            :useEasing="true"
                                        /> -->
                                        <CountTo :startVal="0" :endVal="machineCount || 0" :duration="1000"
                                            :decimals="0" separator="," :autoplay="true" :useEasing="true" />
                                    </div>
                                </div>
                                <div class="stat-item">
                                    <div class="stat-label">用户数（个）</div>
                                    <div class="stat-value orange">
                                        <CountTo :startVal="0" :endVal="userCount || 3892236" :duration="1000"
                                            :decimals="0" separator="," :autoplay="true" :useEasing="true" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 右侧面板 -->
                <div class="panel-wrapper right-panel">
                    <h3 class="panel-title">印量与收益走势</h3>
                    <div class="panel">
                        <div class="panel-content">
                            <TrendChart :fontSizes="chartFontSizes" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 下半区 -->
            <div class="bottom-section">
                <!-- 下半区面板1 -->
                <div class="panel-wrapper bottom-panel-1">
                    <h3 class="panel-title">部署行业分布</h3>
                    <div class="panel" style="padding: 10px;">
                        <div class="panel-content">
                            <IndustryDistribution :fontSizes="chartFontSizes" />
                        </div>
                    </div>
                </div>

                <!-- 下半区面板2 -->
                <div class="panel-wrapper bottom-panel-2">
                    <h3 class="panel-title">设备运行状态</h3>
                    <div class="panel">
                        <div class="panel-content">
                            <DeviceStatus :fontSizes="chartFontSizes" :machineReportData="machineReportData"
                                :loading="initMachineReportLoading && machineReportLoading" />
                        </div>
                    </div>
                </div>

                <!-- 下半区面板3 -->
                <div class="panel-wrapper bottom-panel-3">
                    <h3 class="panel-title">设备类型分布</h3>
                    <div class="panel">
                        <div class="panel-content">
                            <DeviceTypeDistribution :fontSizes="chartFontSizes" />
                        </div>
                    </div>
                </div>

                <!-- 下半区面板4 -->
                <div class="panel-wrapper bottom-panel-4">
                    <h3 class="panel-title">订单量走势</h3>
                    <div class="panel">
                        <div class="panel-content">
                            <OrderTrendChart :fontSizes="chartFontSizes" />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import * as echarts from 'echarts'
// 引入中国地图数据（根据你的需求可以引入其他地图）
import 'echarts/map/js/china'
import CountTo from 'vue-count-to'
import { mapActions, mapGetters } from 'vuex'
import { getMachineReport } from '@/api/dashboard'
import IndustryDistribution from './components/IndustryDistribution.vue'
import ChinaDeviceMap from './components/ChinaDeviceMap.vue'
import TrendChart from './components/TrendChart.vue'
import DeviceStatus from './components/DeviceStatus.vue'
import OrderTrendChart from './components/OrderTrendChart.vue'
import DeviceTypeDistribution from './components/DeviceTypeDistribution.vue'

export default {
  name: 'Dashboard',
  components: {
    CountTo,
    IndustryDistribution,
    ChinaDeviceMap,
    TrendChart,
    DeviceStatus,
    OrderTrendChart,
    DeviceTypeDistribution
  },
  data () {
    return {
      currentDateTime: '',
      scaleRatio: 1,
      baseWidth: 1920,
      baseHeight: 1080,
      // 印量总数
      totalPrintCount: 79892239,
      // 上一次的印量总数
      previousPrintCount: 0,
      // 设备运行状态数据
      machineReportData: {
        normal: 0,
        offLine: 0,
        error: 0,
        expire: 0
      },
      // 设备运行状态加载状态
      machineReportLoading: false,
      initMachineReportLoading: true,
      // 图表字体大小配置
      chartFontSizes: {
        titleFontSize: 16,
        legendFontSize: 12,
        axisLabelFontSize: 10,
        axisNameFontSize: 12,
        tooltipFontSize: 14,
        dataLabelFontSize: 11,
        smallFontSize: 8,
        largeFontSize: 18
      },
      // 定时器引用
      timeTimer: null,
      dataTimer: null,
      homeCountsTimer: null,
      healthCheckTimer: null,
      resizeTimer: null
    }
  },
  computed: {
    ...mapGetters([
      'totalPages',
      'todayPages',
      'todayOrderCount',
      'machineCount',
      'userCount',
      'dashboardLoading'
    ]),
    // 计算运行中+离线设备数量
    runningDeviceCount () {
      return this.machineReportData.normal + this.machineReportData.offLine
    }
  },
  async mounted () {
    this.initDateTime()
    this.initResponsive()

    // 获取印量数据和首页统计数据
    this.loadPrintVolumeData()
    this.loadHomeCounts()
    this.loadMachineReport()

    // 每秒更新时间
    this.timeTimer = setInterval(() => {
      this.initDateTime()
    }, 1000)

    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize)

    // 定期更新数据（每1分钟）
    this.dataTimer = setInterval(async () => {
      await this.loadMachineReport()
    }, 60000)

    // loadHomeCounts每30秒更新一次
    this.homeCountsTimer = setInterval(async () => {
      await this.loadPrintVolumeData()
      await this.loadHomeCounts()
    }, 3000)

    // 启动图表健康检查
    this.startHealthCheck()
  },
  beforeDestroy () {
    // 清理定时器
    if (this.timeTimer) {
      clearInterval(this.timeTimer)
      this.timeTimer = null
    }
    if (this.dataTimer) {
      clearInterval(this.dataTimer)
      this.dataTimer = null
    }
    if (this.homeCountsTimer) {
      clearInterval(this.homeCountsTimer)
      this.homeCountsTimer = null
    }
    if (this.healthCheckTimer) {
      clearInterval(this.healthCheckTimer)
      this.healthCheckTimer = null
    }
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = null
    }
    // 清理事件监听器
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions([
      'getPrintVolumeTotal',
      'getHomeCounts'
    ]),

    // 加载印量数据
    async loadPrintVolumeData () {
      try {
        const data = await this.getPrintVolumeTotal()
        // 更新印量总数，实现滚动效果
        this.updatePrintCount(data.totalPages)
      } catch (error) {
        console.error('获取印量数据失败:', error)
      }
    },

    // 加载首页统计数据
    async loadHomeCounts () {
      try {
        await this.getHomeCounts()
      } catch (error) {
        console.error('获取首页统计数据失败:', error)
      }
    },

    // 加载设备运行状态数据
    async loadMachineReport () {
      try {
        this.machineReportLoading = true
        const res = await getMachineReport()
        if (res.data.status) {
          this.machineReportData = {
            normal: res.data.data.normal || 0,
            offLine: res.data.data.offLine || 0,
            error: res.data.data.error || 0,
            expire: res.data.data.expire || 0
          }
        } else {
          console.error('获取设备运行状态数据失败:', res.data.msg)
        }
      } catch (error) {
        console.error('获取设备运行状态数据失败:', error)
      } finally {
        this.machineReportLoading = false
        this.initMachineReportLoading = false
      }
    },

    initDateTime () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hour = String(now.getHours()).padStart(2, '0')
      const minute = String(now.getMinutes()).padStart(2, '0')
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const weekDay = weekDays[now.getDay()]

      this.currentDateTime = `${year}年${month}月${day}日 ${hour}:${minute} ${weekDay}`
    },

    // 初始化响应式设计
    initResponsive () {
      this.calculateScale()
      this.applyDynamicStyles()
      this.updateChartFontSizes()
    },

    // 计算缩放比例
    calculateScale () {
      const screenWidth = window.innerWidth
      const screenHeight = window.innerHeight

      // 基于宽度和高度计算缩放比例，取较小值确保完整显示
      const widthRatio = screenWidth / this.baseWidth
      const heightRatio = screenHeight / this.baseHeight

      this.scaleRatio = Math.min(widthRatio, heightRatio)

      // 设置最小和最大缩放限制
      this.scaleRatio = Math.max(0.5, Math.min(this.scaleRatio, 2))
    },

    // 应用动态样式
    applyDynamicStyles () {
      const root = document.documentElement
      const screenWidth = window.innerWidth
      const screenHeight = window.innerHeight

      // 基于屏幕尺寸的智能字体缩放
      const fontScale = this.calculateFontScale(screenWidth, screenHeight)

      // 设置CSS自定义属性
      root.style.setProperty('--scale-ratio', this.scaleRatio)

      // 字体大小 - 使用智能缩放
      root.style.setProperty('--base-font-size', `${16 * fontScale}px`)
      root.style.setProperty('--title-font-size', `${23 * fontScale}px`)
      root.style.setProperty('--large-font-size', `${70 * fontScale}px`)
      root.style.setProperty('--medium-font-size', `${28 * fontScale}px`)
      root.style.setProperty('--small-font-size', `${18 * fontScale}px`)
      root.style.setProperty('--extra-large-font-size', `${60 * fontScale}px`)
      root.style.setProperty('--extra-small-font-size', `${12 * fontScale}px`)

      // 间距和尺寸 - 使用基础缩放
      root.style.setProperty('--base-padding', `${20 * this.scaleRatio}px`)
      root.style.setProperty('--base-gap', `${20 * this.scaleRatio}px`)
      root.style.setProperty('--panel-padding', `${20 * this.scaleRatio}px`)
      root.style.setProperty('--border-radius', `${12 * this.scaleRatio}px`)

      // 图表最小高度 - 基于屏幕高度的百分比
      const chartHeight = Math.max(200, screenHeight * 0.25)
      root.style.setProperty('--chart-min-height', `${chartHeight}px`)

      // 响应式布局调整
      this.applyLayoutAdjustments(screenWidth, screenHeight)
    },

    // 计算字体缩放比例
    calculateFontScale (width, height) {
      // 基于屏幕面积的智能缩放
      const area = width * height
      const baseArea = this.baseWidth * this.baseHeight // 1920 * 1080

      let fontScale = Math.sqrt(area / baseArea)

      // 设置字体缩放的合理范围
      fontScale = Math.max(0.6, Math.min(fontScale, 2.5))

      // 对于超宽屏，适当减少字体缩放
      const aspectRatio = width / height
      if (aspectRatio > 2.5) {
        fontScale *= 0.9
      }

      return fontScale
    },

    // 计算图表字体大小
    calculateChartFontSizes () {
      const screenWidth = window.innerWidth
      const screenHeight = window.innerHeight
      const fontScale = this.calculateFontScale(screenWidth, screenHeight)

      // 智能字体倍数：根据分辨率动态调整
      let baseFontMultiplier = 1.0

      // 根据屏幕宽度智能调整字体倍数
      if (screenWidth >= 2560) {
        // 4K及以上超大屏：需要更大字体
        baseFontMultiplier = 1.6
      } else if (screenWidth >= 1920) {
        // 1080P大屏：适度增大字体
        baseFontMultiplier = 1.3
      } else if (screenWidth >= 1366) {
        // 标准分辨率：轻微增大字体
        baseFontMultiplier = 1.1
      } else {
        // 小屏幕：保持原始大小
        baseFontMultiplier = 1.0
      }

      return {
        // 图表标题字体
        titleFontSize: Math.round(16 * fontScale * baseFontMultiplier),
        // 图例字体
        legendFontSize: Math.round(12 * fontScale * baseFontMultiplier),
        // 坐标轴标签字体
        axisLabelFontSize: Math.round(10 * fontScale * baseFontMultiplier),
        // 坐标轴名称字体
        axisNameFontSize: Math.round(12 * fontScale * baseFontMultiplier),
        // 提示框字体
        tooltipFontSize: Math.round(14 * fontScale * baseFontMultiplier),
        // 数据标签字体
        dataLabelFontSize: Math.round(11 * fontScale * baseFontMultiplier),
        // 小字体（如副标题）
        smallFontSize: Math.round(8 * fontScale * baseFontMultiplier),
        // 大字体（如重要数值）
        largeFontSize: Math.round(18 * fontScale * baseFontMultiplier)
      }
    },

    // 应用布局调整
    applyLayoutAdjustments (width, height) {
      const root = document.documentElement

      // 小屏幕布局调整
      if (width < 768) {
        root.style.setProperty('--layout-direction', 'column')
        root.style.setProperty('--grid-columns', '1fr')
      } else if (width < 992) {
        root.style.setProperty('--layout-direction', 'row')
        root.style.setProperty('--grid-columns', '1fr 1fr')
      } else {
        root.style.setProperty('--layout-direction', 'row')
        root.style.setProperty('--grid-columns', '1fr 1fr 1fr 1fr')
      }
    },

    // 处理窗口大小变化（防抖处理）
    handleResize () {
      // 清除之前的定时器
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }

      // 设置防抖延迟
      this.resizeTimer = setTimeout(() => {
        this.calculateScale()
        this.applyDynamicStyles()
        this.updateChartFontSizes()
        this.resizeTimer = null
      }, 300) // 300ms防抖延迟
    },

    // 图表健康检查机制
    checkChartsHealth () {
      // 检查所有图表组件的引用
      const chartRefs = ['trendChart', 'industryChart', 'orderTrendChart', 'chinaDeviceMap']

      chartRefs.forEach(refName => {
        const chartComponent = this.$refs[refName]
        if (chartComponent) {
          // 检查图表实例是否存在且未被销毁
          const chartInstance = chartComponent.chartInstance || chartComponent.chart
          if (!chartInstance || chartInstance.isDisposed()) {
            console.warn(`图表 ${refName} 实例丢失，正在重新初始化...`)
            // 尝试重新初始化图表
            if (typeof chartComponent.initChart === 'function') {
              try {
                chartComponent.initChart()
              } catch (error) {
                console.error(`重新初始化图表 ${refName} 失败:`, error)
              }
            }
          }
        }
      })
    },

    // 启动健康检查定时器
    startHealthCheck () {
      // 每30秒检查一次图表健康状态
      this.healthCheckTimer = setInterval(() => {
        this.checkChartsHealth()
      }, 30000)
    },

    // 更新图表字体大小
    updateChartFontSizes () {
      this.chartFontSizes = this.calculateChartFontSizes()
    },

    // 更新印量总数
    updatePrintCount (newCount) {
      this.previousPrintCount = this.totalPrintCount
      this.totalPrintCount = newCount
    }

  }
}
</script>

<style lang="less" scoped>
// 科技感动画
@keyframes tech-glow {

    0%,
    100% {
        box-shadow: 0 0 5px rgba(0, 212, 255, 0.5), 0 0 10px rgba(0, 212, 255, 0.3), 0 0 15px rgba(0, 212, 255, 0.1);
    }

    50% {
        box-shadow: 0 0 10px rgba(0, 212, 255, 0.8), 0 0 20px rgba(0, 212, 255, 0.5), 0 0 30px rgba(0, 212, 255, 0.3);
    }
}

@keyframes pulse {

    0%,
    100% {
        opacity: 0.6;
    }

    50% {
        opacity: 1;
    }
}

@keyframes scan-line {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(100vw);
    }
}

@keyframes corner-glow {

    0%,
    100% {
        opacity: 0.8;
    }

    50% {
        opacity: 1;
    }
}

.dashboard-container {
    width: 100%;
    height: 100vh;
    background:
        radial-gradient(ellipse 80% 60% at center, rgba(20, 80, 180, 0.6) 0%, rgba(15, 60, 140, 0.5) 30%, rgba(10, 40, 100, 0.7) 60%, rgba(5, 20, 60, 0.9) 100%),
        linear-gradient(135deg, #001240 0%, #1a3366 25%, #2d4d80 50%, #1a3366 75%, #001240 100%);
    position: relative;
    overflow: hidden;
    font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
    font-size: ~"var(--base-font-size)";

    // 科技感网格背景 - 更细密的网格
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image:
            linear-gradient(rgba(0, 150, 255, 0.15) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 150, 255, 0.15) 1px, transparent 1px);
        background-size: 25px 25px;
        z-index: 1;
        animation: pulse 6s ease-in-out infinite;
    }

    // 动态扫描线效果
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: -150px;
        width: 150px;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(0, 150, 255, 0.3), transparent);
        z-index: 2;
        animation: scan-line 10s linear infinite;
    }
}

.tech-lines {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;

    .line-top {
        position: absolute;
        top: 8px;
        left: 0;
        width: 100%;
        height: 6px;
        background: linear-gradient(90deg,
                transparent 0%,
                #ff8c00 5%,
                #ffa500 15%,
                #00bfff 35%,
                #0080ff 50%,
                #00bfff 65%,
                #ffa500 85%,
                #ff8c00 95%,
                transparent 100%);
        animation: tech-glow 3s ease-in-out infinite;
        border-radius: 3px;
        box-shadow: 0 0 15px rgba(255, 140, 0, 0.5);
    }

    .line-bottom {
        position: absolute;
        bottom: ~"calc(var(--base-padding) * 0.5)";
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
        height: ~"calc(var(--scale-ratio) * 4px)";
        background: linear-gradient(90deg, transparent, rgba(255, 140, 0, 0.9), rgba(255, 165, 0, 0.8), transparent);
        border-radius: ~"calc(var(--scale-ratio) * 2px)";
        box-shadow: 0 0 ~"calc(var(--scale-ratio) * 15px)" rgba(255, 140, 0, 0.6);
    }

    .corner {
        position: absolute;
        width: ~"calc(var(--scale-ratio) * 40px)";
        height: ~"calc(var(--scale-ratio) * 40px)";
        border: ~"calc(var(--scale-ratio) * 2px)" solid #0096ff;
        animation: corner-glow 4s ease-in-out infinite;

        &.corner-tl {
            top: ~"var(--base-padding)";
            left: ~"var(--base-padding)";
            border-right: none;
            border-bottom: none;
            border-top-left-radius: ~"calc(var(--border-radius) * 0.67)";
        }

        &.corner-tr {
            top: ~"var(--base-padding)";
            right: ~"var(--base-padding)";
            border-left: none;
            border-bottom: none;
            border-top-right-radius: ~"calc(var(--border-radius) * 0.67)";
        }

        &.corner-bl {
            bottom: ~"var(--base-padding)";
            left: ~"var(--base-padding)";
            border-right: none;
            border-top: none;
            border-bottom-left-radius: ~"calc(var(--border-radius) * 0.67)";
        }

        &.corner-br {
            bottom: ~"var(--base-padding)";
            right: ~"var(--base-padding)";
            border-left: none;
            border-top: none;
            border-bottom-right-radius: ~"calc(var(--border-radius) * 0.67)";
        }
    }
}

.dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ~"calc(var(--base-padding) * 0.75)" ~"calc(var(--base-padding) * 2)";
    background: rgba(10, 15, 46, 0.95);
    border-bottom: ~"calc(var(--scale-ratio) * 2px)" solid rgba(0, 68, 150, 1);
    backdrop-filter: blur(15px);
    position: relative;
    z-index: 3;
    // box-shadow: 0 ~"calc(var(--scale-ratio) * 2px)" ~"var(--base-padding)" rgba(0, 68, 150, );

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg,
                rgba(255, 107, 53, 0.1) 0%,
                transparent 30%,
                rgba(0, 150, 255, 0.1) 70%,
                transparent 100%);
        z-index: -1;
    }

    .header-left {
        flex: 1;
        display: flex;
        align-items: center;

        .logo-container {
            display: flex;
            align-items: center;

            .logo-icon {
                width: ~"calc(var(--scale-ratio) * 100px)";
                height: ~"calc(var(--scale-ratio) * 50px)";

                .logo-img {
                    width: ~"calc(var(--scale-ratio) * 100px)";
                }
            }
        }
    }

    .header-center {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        .title {
            font-size: ~"calc(var(--title-font-size) * 1.56)";
            /* 28px相对于18px的比例 */
            color: #ffffff;
            font-weight: bold;
            text-shadow: 0 0 ~"var(--base-padding)" rgba(255, 255, 255, 0.9), 0 0 ~"calc(var(--base-padding) * 2)" rgba(0, 220, 255, 0.8);
            letter-spacing: ~"calc(var(--scale-ratio) * 2px)";
        }
    }

    .header-right {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .datetime {
            font-size: ~"var(--title-font-size)";
            color: #b8d4f0;
            font-weight: 500;
            text-shadow: 0 0 ~"calc(var(--base-padding) * 0.75)" rgba(184, 212, 240, 0.8);
        }
    }
}

.dashboard-main {
    padding: ~"var(--base-padding)" ~"calc(var(--base-padding) * 1.5)";
    /* 严谨计算高度：100vh - header高度 - 上下padding - 底部装饰线条空间 */
    height: ~"calc(100vh - calc(var(--base-padding) * 2) - calc(var(--scale-ratio) * 60px) - calc(var(--base-padding) * 2))";
    position: relative;
    z-index: 3;
    display: flex;
    flex-direction: column;
    gap: var(--base-gap);

    .top-section {
        display: flex;
        gap: ~"calc(var(--base-gap) * 0.6)";
        /* 严谨计算上半区高度 */
        height: ~"calc((100% - var(--base-gap)) * 0.5)";
        flex: none;
        /* 使用固定高度而非flex比例 */

        .panel-wrapper {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            height: 100%;
        }
    }

    .bottom-section {
        // overflow: hidden;
        display: grid;
        grid-template-columns: ~"var(--grid-columns, 1fr 1fr 1fr 1fr)";
        gap: ~"calc(var(--base-gap) * 0.6)";
        /* 严谨计算下半区高度 */
        height: ~"calc((100% - var(--base-gap)) * 0.55)";
        flex: none;
        /* 使用固定高度而非flex比例 */

        .panel-wrapper {
            min-width: 0;
            display: flex;
            flex-direction: column;
            height: ~"calc(100% - 5px)";
        }

        /* 响应式布局调整 */
        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        @media (min-width: 769px) and (max-width: 992px) {
            grid-template-columns: 1fr 1fr;
        }

        @media (min-width: 993px) {
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }
    }
}

// 面板容器样式
.panel-wrapper {
    .panel-title {
        color: #ffffff;
        font-size: ~"var(--title-font-size)";
        font-weight: bold;
        margin: 0 0 ~"calc(var(--base-padding) * 0.5)" 0;
        text-align: center;
        position: relative;
        z-index: 2;
        text-shadow: 0 0 ~"calc(var(--scale-ratio) * 10px)" rgba(255, 255, 255, 0.8), 0 0 ~"calc(var(--scale-ratio) * 20px)" rgba(0, 220, 255, 0.8);
        padding: 0;
        background: transparent;

        &::after {
            content: '';
            position: absolute;
            bottom: ~"calc(var(--base-padding) * -0.25)";
            left: 50%;
            transform: translateX(-50%);
            width: ~"calc(var(--base-padding) * 3)";
            height: ~"calc(var(--scale-ratio) * 2px)";
            background: linear-gradient(90deg, transparent, #0096ff, transparent);
            border-radius: 1px;
        }
    }
}

/* 面板通用样式 */
.panel {
    background: rgba(1, 17, 64, 0.7);
    border: 1px solid rgba(0, 68, 150, 1);
    border-radius: ~"var(--border-radius)";
    padding: ~"calc(var(--base-padding) * 0.8)";
    // backdrop-filter: blur(8px);
    position: relative;
    transition: all 0.3s ease;
    flex: 1;
    /* 自动填充剩余空间 */
    min-height: 0;
    /* 防止flex布局问题 */
    // box-shadow: 0 0 ~"calc(var(--scale-ratio) * 15px)" rgba(0, 220, 255, 0.3), inset 0 0 20px rgba(0, 191, 255, 0.1);

    &:hover {
        // border-color: rgba(0, 220, 255, 1);
        // box-shadow: 0 0 ~"calc(var(--scale-ratio) * 25px)" rgba(0, 220, 255, 0.5), inset 0 0 30px rgba(0, 191, 255, 0.15);
        transform: translateY(-2px);
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg,
                rgba(0, 212, 255, 0.05) 0%,
                transparent 30%,
                rgba(255, 51, 102, 0.05) 70%,
                transparent 100%);
        border-radius: ~"var(--border-radius)";
        pointer-events: none;
        z-index: 1;
    }

    .panel-content {
        width: 100%;
        height: 100%;
        /* 设置为100%自适应 */
        position: relative;
        z-index: 2;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        color: #87ceeb;
        font-size: 14px;

        /* &::before {
            content: '内容区域';
            opacity: 0.6;
        } */
    }
}

/* 图表容器样式 */
.chart-container {
    width: 100%;
    height: 100%;
    min-height: ~"var(--chart-min-height)";
    position: relative;
}

/* 透明面板样式 */
.transparent-panel {
    background: transparent !important;
    backdrop-filter: none !important;
    border: none;

    &::before {
        display: none !important;
    }

    &:hover {
        background: transparent !important;
        border-color: rgba(0, 212, 255, 0.4) !important;
        box-shadow: none !important;
    }
}

/* 云知印印量总数样式 */
.total-count-display {
    text-align: center;
    margin: ~"calc(var(--base-padding) * 2.5)" 0 ~"calc(var(--base-padding) * 4)" 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .main-number {
        font-size: ~"var(--large-font-size)";
        font-weight: bold;
        color: #FFF;
        text-shadow: 0 0 ~"calc(var(--scale-ratio) * 20px)" rgba(0, 150, 255, 0.8);
        letter-spacing: ~"calc(var(--scale-ratio) * 2px)";
        display: inline;
    }

    .unit {
        font-size: ~"var(--medium-font-size)";
        color: #FFF;
        font-weight: 500;
        display: inline;
        margin-left: ~"calc(var(--base-padding) * 0.5)";
    }
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ~"var(--base-gap)";
    margin-top: 20px;

    // 针对不同分辨率的优化
    @media (max-width: 1366px) {
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: ~"calc(var(--base-gap) * 0.5)";
    }

    .stat-item {
        text-align: center;

        .stat-label {
            font-size: ~"var(--small-font-size)";
            color: #87ceeb;
            margin-bottom: ~"calc(var(--base-padding) * 0.5)";
            font-weight: 400;
        }

        .stat-value {
            font-size: ~"var(--medium-font-size)";
            font-weight: bold;
            color: #b8d4f0;
            display: flex;
            align-items: center;
            justify-content: center;

            &.orange {
                color: #FFBE00;
                text-shadow: 0 0 ~"calc(var(--scale-ratio) * 15px)" rgba(255, 107, 53, 0.6);
            }

            .unit-small {
                font-size: 16px;
                color: #FFBE00;
                margin-left: 5px;
                vertical-align: middle;
                line-height: 1;
                margin-top: -2px;
            }
        }
    }
}

/* 动态响应式设计 - 所有尺寸通过JavaScript动态计算 */
/* 不再需要固定的媒体查询规则 */
</style>
